import { basicInitialState } from '../_utils/basicInitialState';
import { TAreaState } from 'store';

export const areasInitialState: TAreaState = {
  ...basicInitialState,
  areas: null,
  selectedAreas: [],
  zones: null
};
